import { FunctionComponent, useEffect } from "react";

import { Shimmer, useFieldContext } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { useAssignedUserSecurityRoles } from "@libs/api/gateways/plt/plt-gateway.hooks";

import { getUserSecurityInitialValues } from "./user-security.utils";
import { UserSecurityFormValues } from "./UserSecurityForm";
import { SecurityRoleAssignmentsDto } from "@libs/api/gateways/plt/plt-gateway.dtos";

interface UserAssignedSecurityRolesFetcherProps {
  userId: string;
  tenantId: string;
  businessRoles: string[];
  children: (data: SecurityRoleAssignmentsDto[]) => React.JSX.Element;
}
export const UserAssignedSecurityRolesFetcher: FunctionComponent<UserAssignedSecurityRolesFetcherProps> = ({
  businessRoles,
  userId,
  tenantId,
  children
}) => {
  const { setFieldValue } = useFieldContext<
    UserSecurityFormValues["securityRoles"]
  >("securityRoles");

  const {
    data: assignSecRoles,
    isLoading: isLoadingAssignSecRoles,
    error: errorAssignSecRoles
  } = useAssignedUserSecurityRoles({
    tenantId,
    userId,
    businessRoles
  });

  useEffect(() => {
    if (assignSecRoles && businessRoles.length) {
      const values = getUserSecurityInitialValues(assignSecRoles);
      setFieldValue(values.securityRoles);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignSecRoles]);

  return (
    <QueryStateIndicator
      isLoading={isLoadingAssignSecRoles}
      error={errorAssignSecRoles}
      data={assignSecRoles}
      LoadingComponent={
        <>
          {Array.from({ length: 6 }, (_, index) => (
            <Shimmer
              key={index}
              styles={{
                shimmerWrapper: { opacity: 1 - index / 10 }
              }}
            />
          ))}
        </>
      }
    >
      {children}
    </QueryStateIndicator>
  );
};
